/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {GroupedCompetitionItem} from "types/entities/GroupedPackageItem";
import CompetitionWithOptions from "pages/Front/Booking/Competitions/components/CompetitionWithOptions";
import CompetitionWithoutOptions from "pages/Front/Booking/Competitions/components/CompetitionWithoutOptions";

interface CompetitionsListProps {
    competitions: GroupedCompetitionItem[];
}

const CompetitionsList = (props: CompetitionsListProps) => {
    return (
        <div className={"CompetitionsList flex flex-col items-center justify-center gap-y-3 sm:gap-y-4 w-full"}>
            {props.competitions.map((competition, index) =>
                competition.items.length > 1 ? (
                    <CompetitionWithOptions competition={competition} key={`variant-${competition.variant_id}-${index}`} />
                ) : (
                    <CompetitionWithoutOptions competition={competition} key={`item-${competition.items[0].guid || competition.items[0].id}-${index}`} />
                )
            )}
        </div>
    );
};

export default CompetitionsList;
